import React from 'react'
import {
  Box,
  Container,
  Grid,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
  styled,
  Avatar,
} from '@mui/material'
import QuoteIcon from '../../Assets/Icons/qoute.svg'
import HCarosel from '../../Component/Carosel/Header_Carosel'
import KakaPhoto from '../../Assets/Images/Kaka-venkataswamy-2-768x538 1.png'

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: '100%',
  height: 'auto',
  maxWidth: 350,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  marginBottom: theme.spacing(2),
}))

const EmployeeCard = ({ employee }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        textAlign: 'center',
      }}
    >
      <StyledAvatar
        src={employee.image_path}
        alt={employee.employe_name}
        variant="rounded"
      />
      <Typography variant="h6" gutterBottom>
        {employee.employe_name}
      </Typography>
      <Typography variant="subtitle1" color="primary" gutterBottom>
        {employee.designation}
      </Typography>
      {employee.description && (
        <Typography variant="body2" color="primary">
          {employee.description}
        </Typography>
      )}
    </Box>
  )
}

const AboutUs = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const employeeData = [
    {
      employe_name: 'Dr.G. Vivek Venkatswamy',
      designation: 'CHAIRMAN',
      description: 'MLA (CHENNURU)',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/dr-vivek.jpg',
    },
    {
      employe_name: 'Dr.G. Vinod',
      designation: 'SECRETARY',
      description: 'MLA (BELLAMPALLI)',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/G-Vinod-Kumar.jpg',
    },
    {
      employe_name: 'Dr.G. Saroja Vivekanand',
      designation: 'CORRESPONDENT',
      description: 'Managing Director – Visaka Industries',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/g-saroja.jpg',
    },
    {
      employe_name: 'G. RAMA',
      designation: 'JOINT SECRETARY',
      description: 'DBRAEI Joint secretary',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/g-rama.jpg',
    },
    {
      employe_name: 'PV Ramana Kumar',
      designation: 'JOINT SECRETARY',
      description: 'DBRAEI Joint secretary',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/ramana-kumar.jpg',
    },
  ]

  const directorData = [
    {
      employe_name: 'Prof. Vishnu Priya',
      designation: 'DIRECTOR ACADEMICS',
      description: '',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/DBRAEI_Director.jpg',
    },
    {
      employe_name: 'Dr. M Shekar',
      designation: 'Principal',
      description: '',
      image_path:
        'https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/GoverningMembers/Dr. M Shekar.jpg',
    },
  ]
  return (
    <Box sx={{ backgroundColor: '#DFE5F0', minHeight: '100vh' }}>
      <HCarosel />

      {/* Quote Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 2,
          }}
        >
          <Box
            component="img"
            src={QuoteIcon}
            alt="Quote"
            sx={{ width: isMobile ? 24 : 32 }}
          />
          <Typography
            variant={isMobile ? 'h4' : 'h2'}
            align="center"
            sx={{ fontWeight: 'bold' }}
          >
            Education is the key to a better future.
          </Typography>
        </Box>
      </Container>

      {/* Founder Section */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <StyledAvatar src={KakaPhoto} alt="Kaka Venkataswamy" />
            <Typography variant="h5" gutterBottom>
              Late Sri G Venkat Swamy
            </Typography>
            <Typography color="primary" variant="subtitle1">
              Founder and Chairman
            </Typography>
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography variant="h4" gutterBottom>
              About The Founder
            </Typography>
            <Typography variant="body1" paragraph>
              Born on October 5, 1929, the late Sri G Venkat Swamy, Founder and
              Chairman of Dr. B. R. Ambedkar Educational Institutions was the
              visionary behind setting up of these group of establishments. With
              an analytical mind, infinite capacity for work, and a knack for
              human relations, he also functioned as a veteran Congress leader
              and Ex-Union minister for the Government of India.
            </Typography>
            <Typography variant="body1" paragraph>
              Popularly known as 'Kaka', his political career began in 1950 and
              spanned five decades. Kaka was a four-time Member of Parliament
              and served his last term in 2004. One who worked towards improving
              living conditions of the weaker sections of the society, he was
              also the General Secretary of the National Huts Union in
              Hyderabad, providing permanent accommodation for 75,000 hut
              dwellers.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* History Section */}
      <Box sx={{ backgroundColor: theme.palette.grey[100], py: 6 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://dbraeiassetmanagement.blob.core.windows.net/dbradc/prod/home/banners/Banner1.png"
                alt="College Campus"
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" gutterBottom>
                Started In 1973
              </Typography>
              <Typography variant="body1" paragraph>
                Dr B R Ambedkar Educational Society began in 1973 by Sri G
                Venkat Swamy and was inaugurated by the then Hon. President of
                India late Sri V. V. Giri. The establishment was later converted
                to a Public Education Trust that had initially aimed to provide
                non-commercial, quality education to the underprivileged
                children, particularly to those from communities deemed as
                minorities by the Government of India.
              </Typography>
              <Typography variant="body1" paragraph>
                Our vibrant infrastructure is a facilitator for the effective
                delivery of our curriculum. Apart from the common central
                facilities, the colleges have well-equipped laboratories,
                lecture halls and seminar halls.
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ mt: 6 }}>
            <Typography variant="h4" gutterBottom>
              Campus
            </Typography>
            <Typography variant="body1" paragraph>
              The campus is spread across 3 acres landscape known for its
              salubrious climate and presents a congenial atmosphere to pursue
              higher studies. Our vibrant infrastructure is a facilitator for
              the effective delivery of our curriculum. Apart from the common
              central facilities, the colleges have well-equipped laboratories,
              lecture halls and seminar halls.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Founders Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Divider sx={{ my: 4 }}>
          <Typography variant="h4" component="span">
            Meet the Founders
          </Typography>
        </Divider>
        <Grid container spacing={2}>
          {employeeData.map((employee, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
              <EmployeeCard employee={employee} />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Directors Section */}
      <Box sx={{ backgroundColor: theme.palette.grey[100], py: 6 }}>
        <Container maxWidth="lg">
          <Divider sx={{ my: 4 }}>
            <Typography variant="h4" component="span">
              Director and Principal
            </Typography>
          </Divider>
          <Grid container spacing={4} justifyContent="center">
            {directorData.map((director, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <EmployeeCard employee={director} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}

export default AboutUs
